// extracted by mini-css-extract-plugin
export var contents = "styles-module--contents--84fc0";
export var desktop = "styles-module--desktop--7431e";
export var headings = "styles-module--headings--3db5a";
export var mobile = "styles-module--mobile--2b618";
export var modal = "styles-module--modal--a63c5";